import useModal from 'antd/lib/modal/useModal';
import { useAuthorization } from 'components/Authorization';
import useSMSCaptcha from 'components/SMSCaptchaButton/hooks/useSMSCaptcha';
import { noop } from 'lodash-es';
import { useCallback, useMemo, useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { sendSMSCaptcha, verifySMS } from 'services/api/admin';
import errorToaster from 'utils/errorToaster';
import { phoneEncode } from 'utils/phoneHelpers';

const useSMSVerify = (disableCaptcha?: boolean) => {
  const { payload } = useAuthorization<Oversea.Token.Payload>();
  const [value, onChange] = useState('');
  const modalProps = useModal();
  const { t } = useTranslate();
  const captchaProps = useSMSCaptcha({
    disabled: disableCaptcha || !payload?.phoneNumber,
    fetch: async () => {
      if (!payload?.phoneNumber) {
        throw new Error('No phone number in token');
      }
      const rsp = await sendSMSCaptcha({ phoneNumber: payload.phoneNumber, purpose: 'verify' })
        .then(noop)
        .catch((e) => {
          errorToaster(e, t('ViewStartups.startups.form.item.captcha.send.error'));
          return false as const;
        });
      return rsp ?? undefined;
    },
  });
  const encodedPhone = useMemo(
    () => (payload?.phoneNumber ? phoneEncode(payload?.phoneNumber) : ''),
    [payload?.phoneNumber],
  );
  const verify = useCallback(() => {
    if (!payload?.phoneNumber) {
      throw new Error('检验电话不能为空');
    }
    return verifySMS({ phone: payload!.phoneNumber, smsCode: value })
      .then((rsp) => rsp.data.data.isMatch)
      .catch((e) => {
        errorToaster(e, '校验失败');
        return false;
      });
  }, [payload, value]);
  return {
    encodedPhone,
    payload,
    captchaProps,
    modalProps,
    value,
    onChange,
    verify,
  };
};

export default useSMSVerify;
